export const GET_LOGO = "GET_LOGO"
export const SET_LOGO = "SET_LOGO"
